export default __webpack_public_path__ + "static/media/award-4.b2d316ec.png";